import React from "react";
import "./TopBar.css";

const TopBar = () => {
  const marqueeContent = [
    "Admission Open - Apply Now!",
    "Scholarship Exam Open - December",
    "New Course Launch - Kindergarten",
    "Annual Sports Day - Coming Soon"
  ];

  return (
    <div className="topbar-container">
      {/* Left Logo */}
      <div className="topbar-logo topbar-logo-left">
        <img 
          src="/images/logo-left.png" 
          alt="School Logo Left" 
          onError={(e) => {
            e.target.src = "/images/logo/logo.png";
          }}
        />
      </div>

      {/* School Name */}
      <div className="topbar-school-name">
        <h1 className="school-name-text">JACK AND JILL MATRICULATION SCHOOL</h1>
      </div>

      {/* Center Marquee */}
      <div className="topbar-marquee-wrapper">
        <div className="topbar-marquee">
          <div className="topbar-marquee-content">
            {marqueeContent.map((item, index) => (
              <span key={index} className="topbar-marquee-item">
                {item}
              </span>
            ))}
            {/* Duplicate for seamless loop */}
            {marqueeContent.map((item, index) => (
              <span key={`dup-${index}`} className="topbar-marquee-item">
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Right Logo */}
      <div className="topbar-logo topbar-logo-right">
        <img 
          src="/images/logo-right.png" 
          alt="School Logo Right" 
          onError={(e) => {
            e.target.src = "/images/logo/founder.png";
          }}
        />
      </div>
    </div>
  );
};

export default TopBar;
